/**
 * Qué trae puesto una pizza al abrir el armador.
 *
 * Vive fuera del componente porque es la parte del 86 que falla EN SILENCIO: si
 * un ingrediente agotado sigue contando como default, el armador lo pre-coloca
 * en la pizza sin que nadie lo toque, y el cliente paga por algo que la cocina
 * no tiene. No hay pantalla roja que lo delate — la pizza simplemente sale con
 * un ingrediente de más.
 *
 * Por eso el armador filtraba los agotados de la lista entera: era la forma
 * barata de que no se auto-colocaran. El costo era que desaparecían, que es
 * justo lo que el dueño no quería ("no quiero que desaparezcan, solo que se
 * marquen"). Con estos dos helpers ya se pueden mostrar apagados: se quedan a la
 * vista, pero fuera de la siembra.
 */

export type SeedOption = { id: string; isDefault: boolean; soldOut?: boolean }
export type SeedGroup = { isSize: boolean; options: readonly SeedOption[] }

/**
 * Ingredientes que la pizza trae puestos de entrada. El grupo de TAMAÑO queda
 * fuera: no es un ingrediente que se coloque sobre la masa, lo gobierna
 * `pickSizeOptionId`.
 */
export function seedDefaultOptionIds(groups: readonly SeedGroup[]): string[] {
  return groups
    .filter((g) => !g.isSize)
    .flatMap((g) => g.options.filter((o) => o.isDefault && !o.soldOut).map((o) => o.id))
}

/**
 * Tamaño con el que abre el armador.
 *
 * Prefiere el default del grupo; si ESE se acabó, cae al primero disponible en
 * vez de dejar la pizza sin tamaño — el grupo de tamaño gobierna la rejilla de
 * precios, y sin él el armador no sabe cuánto cobrar.
 *
 * Devuelve `null` solo cuando NO queda ningún tamaño disponible. Ahí no hay
 * pizza que armar y quien llama debe tratarlo como tal; caer al primer tamaño
 * agotado sería vender lo que no hay.
 */
export function pickSizeOptionId(
  sizeGroup: { options: readonly SeedOption[] } | null | undefined,
): string | null {
  if (!sizeGroup) return null
  const sellable = sizeGroup.options.filter((o) => !o.soldOut)
  return sellable.find((o) => o.isDefault)?.id ?? sellable[0]?.id ?? null
}
